import { createStore } from 'vuex'

export default createStore({
  state: {
    estados: [
      {
        acronym: 'BA',
        name: 'Bahia',
        population: 397.059,
        porcentage: 30
      },
      {
        acronym: 'MA',
        name: 'Maranhão',
        population: 269.074,
        porcentage: 20
      },
      {
        acronym: 'MG',
        name: 'Minas Gerais',
        population: 135.311,
        porcentage: 10
      },
      {
        acronym: 'PA',
        name: 'Pará',
        population: 135.033,
        porcentage: 10
      },
      {
        acronym: 'PE',
        name: 'Pernambuco',
        population: 78.827,
        porcentage: 6
      },
      {
        acronym: 'AL',
        name: 'Alagoas',
        population: 37.722,
        porcentage: 3
      },
      {
        acronym: 'PI',
        name: 'Piauí',
        population: 31.686,
        porcentage: 2
      },
      {
        acronym: 'GO',
        name: 'Goiás',
        population: 30.387,
        porcentage: 2
      },
      {
        acronym: 'SE',
        name: 'Sergipe',
        population: 28.124,
        porcentage: 2
      },
      {
        acronym: 'CE',
        name: 'Ceará',
        population: 23.955,
        porcentage: 2
      },
      {
        acronym: 'RN',
        name: 'Rio Grande do Norte',
        population: 22.384,
        porcentage: 2
      },
      {
        acronym: 'RJ',
        name: 'Rio de Janeiro',
        population: 20.344,
        porcentage: 1
      },
      {
        acronym: 'RS',
        name: 'Rio Grande do Sul',
        population: 17.496,
        porcentage: 1
      },
      {
        acronym: 'PB',
        name: 'Paraíba',
        population: 16.584,
        porcentage: 1
      },
      {
        acronym: 'ES',
        name: 'Espírito Santo',
        population: 15.652,
        porcentage: 1
      },
      {
        acronym: 'TO',
        name: 'Tocantins',
        population: 12.881,
        porcentage: 1
      },
      {
        acronym: 'AP',
        name: 'Amapá',
        population: 12.524,
        porcentage: 1
      },
      {
        acronym: 'MT',
        name: 'Mato Grosso',
        population: 11.719,
        porcentage: 1
      },
      {
        acronym: 'SP',
        name: 'São Paulo',
        population: 10.999,
        porcentage: 1
      },
      {
        acronym: 'PR',
        name: 'Paraná',
        population: 7.113,
        porcentage: 0.5
      },
      {
        acronym: 'SC',
        name: 'Santa Catarina',
        population: 4.447,
        porcentage: 0.3
      },
      {
        acronym: 'RO',
        name: 'Rondônia',
        population: 2.926,
        porcentage: 0.2
      },
      {
        acronym: 'AM',
        name: 'Amazonas',
        population: 2.705,
        porcentage: 0.2
      },
      {
        acronym: 'MS',
        name: 'Mato Grosso do Sul',
        population: 2.546,
        porcentage: 0.2
      },
      {
        acronym: 'DF',
        name: 'Distrito Federal',
        population: 305,
        porcentage: 0.02
      },
      {
        acronym: 'RR',
        name: 'Roraima',
        population: 0,
        porcentage: 0
      },
      {
        acronym: 'AC',
        name: 'Acre',
        population: 0,
        porcentage: 0
      }
    ]
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
